
import { defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import HashInspection from "@/helpers/pages/HashInspection";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useRoute, useRouter } from "vue-router";
import moment from "moment";
const store = useStore();
import EventBus from "@/helpers/EventBus";
import dateOptions from "@/helpers/DateOptions";
import { notify } from "@kyvg/vue3-notification";
import router from "./../../router";

const hashTypes: any = {
  allhashes: "",
  malicious: "Malicious",
  suspicious: "Suspicious",
  harmless: "Harmless",
  notfound: "Notfound",
};

export default defineComponent({
  name: "HashInspection",
  components: { AgCard },
  data() {
    return {
      module: HashInspection,
      tempData: {
        total: 0,
        rows: [],
      },
      threatPath: {
        path: [] as string[],
        pathCount: 0
      },
      pathLoading: false,
    };
  },
  setup() {
    let module = ref(HashInspection);
    const route = useRoute();
    const router = useRouter();

    let filter: any = ref({
      startDate: moment().utc().subtract(7, "days").startOf("day"),
      endDate: moment().utc(),
      groupGuids: [],
      computerGuid: "",
      hash: "",
      hashType: "Malicious",
      fileContent: "",
    });

    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };

    const RESETFILTER = filter;
    const getList = (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      const body = { filters, options };
      if (!body.filters.startDate) {
        body.filters.startDate = moment()
          .subtract(7, "days")
          .utc()
          .startOf("day");
      }
      if (!body.filters.endDate) {
        body.filters.endDate = moment().utc();
      }
      delete filters.range;
      store.dispatch(GeneralActionTypes.GET_HASHES, body);
    };

    const searchWithFilters = (param: any) => {
      if (module.value.filter.filters[0].vmodel) {
        filter.value.groupGuids = module.value.filter.filters[0].vmodel;
      } else {
        filter.value.groupGuids = [];
      }
      const firstType = module.value.filter.filters[3].vmodel || "";
      filter.value.computerGuid = module.value.filter.filters[1].vmodel || "";
      filter.value.hash = module.value.filter.filters[2].vmodel || "";
      filter.value.hashType = module.value.filter.filters[3].vmodel || "";
      if (!filter.value.hashType && route.params.param) {
        const routeParam: any = route.params.param;
        module.value.filter.filters[3].vmodel = hashTypes[routeParam];
        filter.value.hashType = hashTypes[routeParam];
      }

      const date = module.value.filter.filters[4].vmodel ? moment(module.value.filter.filters[4].vmodel) : moment();
      filter.value.endDate = moment().utc();
      filter.value.startDate = date
        .startOf("day")
        .subtract(7, "days")
        .utc();

      if (!param) {
        const findDate: any = module.value.filter.filters.find(
          (f) => f.param == "range"
        );
        if (findDate && findDate.vmodel) {
          if (typeof findDate.vmodel === "object" && findDate.vmodel.end) {
            filter.value.endDate = findDate.vmodel.end;
            filter.value.startDate = findDate.vmodel.start;
          } else {
            console.log(findDate.vmodel);
            filter.value.startDate = findDate.vmodel;
          }
        }
      }

      const filters = filter.value;
      const options = module.value.component.options;
      options.page = 1;
      if (!param) {
        options.loadType = "filter";
      } else {
        options.loadType = "page";
      }

      if (module.value.filter.filters[3].vmodel) {
        options.loadType = "page";
      } 

      module.value.readyToUseFilters = filters;
      if (!param) {
        filters.hashType = firstType;
        module.value.readyToUseFilters = filters;
        router.push({ query: { searchResults: "true" } });
      }
      getList(filters, options);
    };

    const resetFilters = () => {
      module.value.filter.filters.forEach((item: any) => {
        if (item.param == "range") {
          item.vmodel = dateOptions[2].value;
          item.selectedLabel = dateOptions[2].label;
        } else {
          item.vmodel = null;
        }
      });
      searchWithFilters(true);
      let query = Object.assign({}, router.currentRoute.value.query);
      delete query.searchResults;
      router.replace({ query });
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      getList,
    };
  },
  computed: {
    hashParam(): any {
      return this.$route.params.param;
    },
  },
  watch: {
    "$route.params.param"(value) {
      this.filter.hashType = hashTypes[value];
      const filters = this.filter;
      this.module.readyToUseFilters = filters;
      const options = this.module.component.options;
      this.module.component.options.loadType = "page";
      this.getList(filters, options);
    },
  },
  mounted() {
    EventBus.on("hashInspectionLoad", (data: any) => {
      this.loadFilters(data);
      const filters = this.filter;
      this.module.readyToUseFilters = filters;
      const options = this.module.component.options;
      this.getList(filters, options);
    });
    let data: any = this.$route.params.data;
    if (data) {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, true);
      this.loadFiltersIfExist();
      return;
    }
    this.setFilterStatus();
    const routeParam: any = this.$route.params.param;
    this.filter.hashType = hashTypes[routeParam];
    const filters = this.filter;
    this.module.readyToUseFilters = filters;
    const options = this.module.component.options;
    this.getList(filters, options);
  },
  methods: {
    async copyPath(text: any) {
      try {
        await navigator.clipboard.writeText(text);
        notify({
            title: this.$t("Copied"),
            type: "success",
            duration: 4000,
        });
      } catch {
        notify({
            title: this.$t("Cannot Copy"),
            type: "error",
            duration: 4000,
        });
      }
    },
    getThreatPath(data: any) {
      this.pathLoading = true;

      if (data && Array.isArray(data.path)) {
        this.threatPath.path = data.path.map((item: string) => item.toString());
        this.threatPath.pathCount = data.path.length;
      } else {
        this.threatPath.path = [];
        this.threatPath.pathCount = 0;
      }

      this.pathLoading = false;
    },
    mainLink() {
      if (this.tempData.total > 0) {
        this.module.component.options.rows = this.tempData.rows;
        this.module.component.options.total = this.tempData.total;
      }
    },
    search() {
      this.tempData.rows = this.module.component.options.rows;
      this.tempData.total = this.module.component.options.total;
      this.module.component.options.rows = [];
      this.module.component.options.total = 0;
    },
    loadFiltersIfExist() {
      this.module.filter.filters.forEach((item) => {
        item.vmodel = null;
      });
      let data: any = this.$route.params.data;
      if (data != undefined) {
        data = JSON.parse(data);
        data.forEach((item: any) => {
          this.filter[item.name] = item.value;
          this.module.filter.filters.forEach((filter: any) => {
            if (filter.apiEquivalent === "range") {
              if (!filter.vmodel) {
                this.filter["startDate"] = moment()
                  .utc()
                  .add(-7, "days")
                  .utc()
                  .startOf("day");
                this.filter["endDate"] = moment().utc();
              }

              if (this.filter.range)
                this.module.filter.filters[4] = this.filter.range;
              return;
            }
            if (filter.apiEquivalent == item.name) {
              filter.selectedLabel = item.selectedLabel;
              filter.vmodel = item.value;
              return;
            }
          });
        });
      }
    },
    loadFilters(data: any) {
      // let data: any = this.$route.params.data;
      this.module.filter.filters.forEach((item) => {
        item.vmodel = null;
      });
      if (data != undefined) {
        data = JSON.parse(data);
        data.forEach((item: any) => {
          this.filter[item.name] = item.value;
          this.module.filter.filters.forEach((filter) => {
            if (filter.apiEquivalent === "range" && item.name === "range") {
              if (!filter.vmodel) {
                this.filter["startDate"] = item.value.vmodel.start;
                this.filter["endDate"] = item.value.vmodel.end;
              } else {
                this.filter["startDate"] = moment()
                  .utc()
                  .add(-7, "days")
                  .utc()
                  .startOf("day");
                this.filter["endDate"] = moment().utc();
              }

              if (this.filter.range) {
                this.module.filter.filters[4] = this.filter.range;
              }
              return;
            }
            if (filter.apiEquivalent == item.name) {
              filter.selectedLabel = item.selectedLabel;
              filter.vmodel = item.value;
              return;
            }
          });
        });
      }
    },
  },
});
